import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { DisplayTimelineProgress } from 'game/display/DisplayTimelineProgress';

import { ButtonSimple } from '@jollywise/jollygoodgame';

export class Scenario extends SceneBase {
  constructor() {
    super({ key: KEYS.Scenario, active: false });
  }
  create() {
    super.create();
    this.setBackgroundColour(0xc9e3e8);
    this.bg = this.add.image(0, 0, 'backgrounds', 'background_scenario').setOrigin(0);

    this.game.hud.setState('GAME');
    this._documenets = this.game._scenario.getCurrentDocuments;
    this._documentsCount = this._documenets.length;

    // tracking
    this.game._player.trackingScenarioId = { id: this.game._scenario.getCurrentScenarioId };

    // setup evenets to listen out for
    this.game.hud.events.on(
      'CLOSE_SCORES_MODAL',
      () => {
        this.game.hud.setState('GAME');
      },
      this
    );

    this.pointerTweens = null;

    this.add
      .sprite(840, this.game.defaultHeight, 'backgrounds', `background_table`)
      .setOrigin(0.5, 1);

    const negotiatorSprite = this.game._scenario.getNegotiatorSprite;
    this.add.sprite(840, 124, 'ui', `negotiator_${negotiatorSprite}`).setOrigin(0.5, 0);

    this.addDocuments();
    this.timeline = new DisplayTimelineProgress(this);
    this._readDocuments = 0;

    // listen out for event document:close
    this.game.events.on('document:close', this.checkDocumentsRead, this);

    if (this._documentsCount === 0) {
      this.createContinueButton();
    }
  }

  createContinueButton() {
    this.continue = new ButtonSimple(this, {
      x: 840,
      y: this.game.defaultHeight - 40,
      id: 'btn_continue',
      costume: 'btn_continue',
    }).setOrigin(0.5, 1);

    this.continue.alpha = 0;

    this.add.tween({
      targets: this.continue,
      alpha: 1,
      duration: 300,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.continue.on('pointerdown', () => {
          this.game.soundController.playSFX('sfx', 'chn_button_click');

          this.game.startDecision();
        });
      },
    });
  }

  checkDocumentsRead() {
    this._readDocuments <= 1 && this.createContinueButton();
  }

  triggerDocument(id) {
    this.game._scenario.displayScenarioDocument(id);
  }

  makeDocumentsActive() {
    // loop over docsContainer children and make them interactive
    this.docsContainer.list.forEach((doc, i) => {
      doc.setInteractive({ useHandCursor: true });

      doc.on('pointerdown', () => {
        this.game.soundController.playSFX('sfx', 'chn_document_pickup');

        if (this.pointerTweens) {
          this.pointerTweens.destroy();
          this.pointer.destroy();
          this.pointerTweens = null;
        }

        this.add.tween({
          targets: doc,
          y: doc.height,
          alpha: 0,
          duration: 750,
          ease: Phaser.Math.Easing.Back.Out,
          onComplete: () => {
            this.triggerDocument(doc.document_id);
            this._readDocuments++;
            // update sprite texture to read
            setTimeout(() => {
              doc.y = 0;
              doc.alpha = 1;

              doc.setTexture('ui', `document_${doc.document_id + 1}_read`);
            }, 1000);
          },
        });
      });
    });
  }

  triggerDocumentOnboarding() {
    const tweens = [];

    if (this.docPositions.length === 0) return;

    this.pointer = this.add.image(this.docPositions[0].x, this.docPositions[0].y, 'ui', 'pointer');
    this.pointer.alpha = 0;

    this.docPositions.map((doc, i) => {
      tweens.push(
        {
          alpha: { from: 0, to: 1 },
          duration: 300,
          ease: Phaser.Math.Easing.Back.Out,
        },
        {
          scale: { from: 1, to: 0.8 },
          y: { from: doc.y, to: doc.y + 10 },
          duration: 300,
          ease: Phaser.Math.Easing.Back.Out,
        },
        {
          scale: { from: 0.8, to: 1 },
          y: { from: doc.y + 10, to: doc.y },
          duration: 300,
          ease: Phaser.Math.Easing.Back.Out,
        },
        {
          alpha: { from: 1, to: 0 },
          duration: 300,
          ease: Phaser.Math.Easing.Back.Out,
          onComplete: () => {
            if (this.docPositions[i + 1]) {
              this.pointer.x = this.docPositions[i + 1].x;
              this.pointer.y = this.docPositions[i + 1].y;
            } else {
              this.pointer.destroy();
              this.pointerTweens = null;
            }
          },
        }
      );
    });

    this.pointerTweens = this.tweens.chain({
      targets: [this.pointer],
      tweens,
    });

    this.game._player.updateOnboardingStep = 'documents';
  }

  addDocuments() {
    this.docs = [];
    this.docsContainer = this.add.container(840, this.game.defaultHeight - 230);
    const tweens = [];

    this.docPositions = [];

    for (let i = 0; i < this._documentsCount; i++) {
      const id = `document_${i + 1}_unread`;
      const doc = this.add.sprite(0, 0, 'ui', `document_${i + 1}_unread`).setOrigin(0.5);

      doc.y = doc.height;
      doc.document_id = i;

      const defaultPadding = 40;

      if (this._documentsCount === 2)
        doc.x = i === 0 ? -(doc.width / 2 + defaultPadding) : doc.width / 2 + defaultPadding;
      if (this._documentsCount === 3)
        doc.x = i === 0 ? -(doc.width + defaultPadding) : i === 2 ? doc.width + defaultPadding : 0;
      this.docs.push(doc);

      this.docsContainer.add(doc);
      doc.alpha = 0;

      this.docPositions.push({ x: 840 + doc.x, y: this.game.defaultHeight - 230 });

      // if item is last in list add onComplete to tween make documents active
      if (i === this._documentsCount - 1) {
        tweens.push({
          targets: doc,
          alpha: 1,
          y: 0,
          duration: 300,
          ease: Phaser.Math.Easing.Back.Out,
          onComplete: () => {
            this.game.soundController.playSFX('sfx', 'chn_document_pickup');

            this.makeDocumentsActive();

            !this.game._player.onboardingSteps.documents && this.triggerDocumentOnboarding();
          },
        });

        break;
      }

      tweens.push({
        targets: doc,
        alpha: 1,
        y: 0,
        duration: 300,
        ease: Phaser.Math.Easing.Back.Out,
        onComplete: () => {
          this.game.soundController.playSFX('sfx', 'chn_document_pickup');
        },
      });
    }

    tweens.length > 0 &&
      this.tweens.chain({
        tweens,
      });
  }

  shutdown() {
    this.game.hud.events.off(
      'CLOSE_SCORES_MODAL',
      () => {
        this.game.hud.setState('GAME');
      },
      this
    );
    this.timeline.shutdown();
    super.shutdown();
  }
}
